import fs from 'node:fs'
import { schemaFileCandidates } from './schema-file-candidates.js'
import { SchemaNotFoundError } from './schema-not-found-error.js'

export function resolveSchemaFilePath(schemasDir: string, name: string): string {
  const filePaths = schemaFileCandidates(schemasDir, name).filter((filePath) =>
    fs.existsSync(filePath)
  )

  if (filePaths.length === 0) {
    throw new SchemaNotFoundError(name, schemasDir)
  }

  if (filePaths.length > 1) {
    throw new Error(
      `Found multiple schemas named "${name}". Keep only one file: ${filePaths.join(', ')}`
    )
  }

  return filePaths[0]!
}
